
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByMonth,
  GetHighlight,
  SourceURL,
  GetDateFromMonthYear,
  FormatAllFloatFieldsAsPercentNumber,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import Map from "@/components/Map/Map.vue";
import greenSeries from "@/data/greenSeries";
import Legend from "@/components/Map/Legend.vue";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [] as Array<Record<string, any>>,
      metric: {} as Metric,
      summaryDate: new Date(),
      highlight: "",
      active: true,
      rank: "",
      dataProp: "labor_force_participation_rate",
      series: greenSeries,
    };
  },
  components: {
    Spinner,
    MetricGrid,
    MetricTitle,
    SectionTitle,
    MetricStat,
    MetricSource,
    MetricHighlight,
    Map,
    Legend,
  },
  methods: {
    debug(e: any) {
      console.log("debug", e);
    },
    summaryTitle() {
      return SummaryTitleByMonth(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic);
    this.metric = GetMetric(topic); // Get metric configuration
    // Get summary data and hightlights
    const lastItem: any = this.data[this.data.length - 1];
    this.summaryDate = GetDateFromMonthYear(lastItem.month);
    this.rank = lastItem.rank;
    this.highlight = GetHighlight(this.data);
  },
});
